import { mapGetters, mapActions } from 'vuex'
import journal from '@/api/journal'
import { settingJournalAtype } from '@/api/setting'
import section from '@/api/section'
import specialApi from '@/api/special'
import article from '@/api/article'
import manuscript from '@/api/manuscript'
import help from '@/utils/help'
import { discountDetail } from '@/api/discount'
import selectVoucher from './select-voucher'

export default {
  components: {
    selectVoucher
  },
  data() {
    return {
      params: {
        journalId: '',
        articleType: '',
        section: '',
        specialIssue: '',
        specialId: '',
        collections: '',
        title: '',
        abstract: '',
        keyword: [],
        foundationList: []
      },
      founds: [],
      foundation: {
        name: '',
        code: ''
      },
      hasFoun: false,
      flag: false,
      rules: {},
      sectionList: [],
      specialIssueList: [],
      special: {},
      journalList: [],
      collectionsList: [],
      articleTypeList: [],

      journalInfo: {},
      hasDiscount: false,
      discountCode: '',
      discountCodeList: [],
      isVisable: false,
      isEditor: false,
      showUpgradeNotice:
        sessionStorage.getItem('imr-submission-upgrade-notice-dismissed') !==
        '1'
      // nonJournal: ['EJGO', 'JOMH'],
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      publisherInfo: 'getPublisherInfo',
      manuscript: 'getManuscript',
      domain: 'getDomain'
    })
  },
  watch: {
    manuscript: {
      handler(val) {
        this.getFound = help.debounce(async () => {
          this.founds = await article.getFound(this.foundation.name)
        }, 1000)
        if (val.id) {
          // console.log(val, 'valll')
          const {
            journalId,
            foundationList,
            details,
            id,
            version,
            sign,
            discountDetailList
          } = val
          const {
            typeCode,
            sectionId,
            specialId,
            special,
            title,
            summary,
            keyword
          } = details
          specialApi
            .submitManuscript({
              journalId: journalId,
              title: special ? special.titleText : ''
            })
            .then(res => {
              this.specialIssueList = res
            })
          this.params = JSON.parse(
            JSON.stringify({
              id,
              journalId,
              typeCode,
              sectionId,
              specialId,
              title,
              summary,
              keyword,
              version,
              sign,
              keywords: keyword.split(';')
            })
          )
          this.onJournalChange(journalId)
          // this.getSpecial(special ? special.titleText : '')
          this.flag = true
          if (foundationList && foundationList.length) {
            this.hasFoun = true
          }
          if (discountDetailList && discountDetailList.length) {
            this.hasDiscount = true
            this.discountCodeList = discountDetailList
            this.params.discountDetailIdList = this.discountCodeList.map(
              item => item.id
            )
          }
          this.$set(this.params, 'foundationList', foundationList || [])
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (
      this.$route.path ===
      '/editorial-office/manuscripts/submit-manuscripts/step1'
    ) {
      // console.log(this.$route.path, 'path')
      this.isEditor = true
    }
    this.getRules()
    this.getFound()
    this.getJournal()
  },
  methods: {
    ...mapActions(['updateManuscript']),
    async getSpecial(val) {
      this.specialIssueList = await specialApi.submitManuscript({
        journalId: this.params.journalId,
        title: val
      })
    },
    async submit() {
      this.AddFoun()
      const flag = this.$refs[
        'author-submit-manuscripts-information-form'
      ].validate()
      this.params.keyword = this.params.keywords
        ? this.params.keywords.join(';')
        : []
      if (this.params.keyword.length > 2048) {
        this.$message.error({
          title: 'Error',
          content: `The length of keyword is too long and must be less than 2048 bytes.`
        })
        return
      }
      if (flag) {
        if (this.hasFoun) {
          this.params.foundationList.forEach((item, index) => {
            item.sort = index
          })
        }
        const res = await manuscript.step1(this.params)
        this.updateManuscript(res)
        this.$router.push('step2?id=' + res.id)
      }
    },
    async getJournal() {
      this.journalList = await journal.getAll({
        released: true,
        submited: true
      })
      // this.params.journalId =
      //   this.params.journalId ||
      //   // localStorage.getItem('opjournalId') ||
      //   (this.journalList[0] && this.journalList[0].id)

      // this.onJournalChange(this.params.journalId)
    },
    async queryJournal() {
      this.journalInfo = await journal.query(this.params.journalId)
    },
    onJournalChange(val, flag) {
      // localStorage.setItem('opjournalId', val)
      this.getType()
      this.getSpecial()
      this.getSection()
      this.queryJournal()
      if (flag) {
        this.params.specialId = ''
        this.params.sectionId = ''
      }
    },
    async getType() {
      this.articleTypeList = await settingJournalAtype.getAll({
        released: true,
        journalId: this.params.journalId
      })
    },
    async getSection() {
      this.sectionList = await section.getAll({
        journalId: this.params.journalId
      })
    },
    async onSpecialSelect(val) {
      this.special = await specialApi.query(val)
    },
    goToPage(key) {
      if (!this.journalInfo.id) {
        this.$message.error({
          title: 'Error',
          content: `Please select a journal first`
        })
        return
      }
      window.open(this.journalInfo[key])
    },
    onFlagChange(val) {
      this.flag = val
    },
    onHasFunChange() {
      this.hasFoun = !this.hasFoun
      this.foundation = {
        name: '',
        code: ''
      }
      this.params.foundationList = []
    },
    getRules() {
      this.rules = {
        journalId: [
          {
            required: true,
            message: 'Journal' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        typeCode: [
          {
            required: true,
            message: 'Article Type' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        title: [
          {
            required: true,
            message: 'Title' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        summary: [
          {
            required: true,
            message: 'Abstract' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        keywords: [
          {
            required: true,
            min: 1,
            message: 'Keywords' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    },
    onFoundationChange(val) {
      // this.foundation.code = val.code
    },
    delFoun(index) {
      this.params.foundationList.splice(index, 1)
    },
    async AddFoun() {
      if (this.hasFoun && !this.foundation.name && this.foundation.code) {
        this.$message.error({
          title: 'Error',
          content: 'Funding name' + this.LANGUAGE[this.language].noEmpty
        })
        return
      }
      // if (this.hasFoun && this.foundation.name && !this.foundation.code) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: 'Funding number' + this.LANGUAGE[this.language].noEmpty
      //   })
      //   return
      // }
      if (
        this.hasFoun &&
        this.foundation.code &&
        this.foundation.code.length > 1024
      ) {
        this.$message.error({
          title: 'Error',
          content: `The  length of Grant Number is too long and must be less than 1024 bytes.`
        })
        return
      }
      this.getFound()
      if (this.hasFoun && this.foundation.name) {
        const flag = this.params.foundationList.some(item => {
          if (item.code && item.code === this.foundation.code) {
            return true
          }
        })
        if (flag) {
          this.foundation = {
            name: '',
            code: ''
          }
          return
        }
        this.params.foundationList.push(this.foundation)
        this.foundation = {
          name: '',
          code: ''
        }
      }
      if (this.hasFoun && !this.foundation.name && !this.foundation.code) {
        return
      }
    },

    async AddDiscount() {
      if (!this.discountCode) {
        return
      }
      const item = await discountDetail.code(this.discountCode)
      if (!item) {
        this.$message.error({
          title: 'Error',
          content: `wrong coupon code.`
        })
        this.discountCode = ''
        return
      }
      let flag = this.discountCodeList.some(val => {
        return val.code === item.code
      })
      if (flag) {
        this.discountCode = ''
        return
      }
      item.__selected = true
      this.discountCodeList.push(item)
      this.params.discountDetailIdList = this.discountCodeList.map(
        item => item.id
      )
      this.discountCode = ''
      // console.log(
      //   this.discountCodeList,
      //   'this.di',
      //   this.discountCode,
      //   flag,
      //   this.params.discountDetailIdList
      // )
    },
    selectDiscount() {
      this.isVisable = true
    },
    confirmDiscount(val) {
      this.discountCodeList = val
      this.params.discountDetailIdList = this.discountCodeList.map(
        item => item.id
      )
    },
    delDiscount(index) {
      this.discountCodeList.splice(index, 1)
      this.params.discountDetailIdList = this.discountCodeList.map(
        item => item.id
      )
    },

    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this Partner?',
        content:
          'Please be aware of once this Partner is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.dataSource = this.dataSource.filter(item => item.id !== val.id)
      })
    },

    edit(val) {
      const copyVal = JSON.parse(JSON.stringify(val))
      this.$refs['manage-questionnaire-add'].getQuery(copyVal)
      this.isVisable = true
    },
    confirm(val) {
      const confirmIndex = this.dataSource.findIndex(item => item.id === val.id)
      this.dataSource[confirmIndex] = val
      this.$set(this.dataSource, confirmIndex, val)
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    },
    dismissUpgradeNotice() {
      this.showUpgradeNotice = false
      sessionStorage.setItem('imr-submission-upgrade-notice-dismissed', '1')
    }
  }
}
